export default {
    methods: {
        jumpPaymentCenter(goMember = false) {
            document.body.style.overflow = "auto";
            if (!this.$store.getters.loginStatus) {
                window.location.href = this.$loginBack;
                return;
            }
            let hrefIndex = ["member-paymentCenter"];
            let query = {
                backUrl: hrefIndex.includes(this.$route.name) ? window.location.origin + "/" : window.location.href,
            }
            if (this.$store.getters.accountType.length && !goMember) {
                const href = this.$router.resolve({
                    path: "/user/equity"
                }).href;
                window.location.href = href;
                return;
            }
            // if (this.$route.name === "member") return;
            const href = this.$router.resolve({
                path: "/member",
                query,
            }).href;
            window.location.href = href;
        }
    }
}